import { render, staticRenderFns } from "./FormulationItemTab.vue?vue&type=template&id=eb7a705a&scoped=true&"
import script from "./FormulationItemTab.vue?vue&type=script&lang=js&"
export * from "./FormulationItemTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationItemTab.vue?vue&type=style&index=0&id=eb7a705a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7a705a",
  null
  
)

export default component.exports